/**
 * Auth0 Error Utilities
 * Helper functions for handling authentication errors and deep links
 */

const DEEP_LINK_HOSTS = ['byte-pantry.com', 'd01.byte-pantry.com'];

/**
 * Given a URL fired by the OS appUrlOpen event, returns the pathname+search
 * to navigate to if it's a recognised Byte Pantry deep link, or null otherwise.
 */
export function resolveDeepLinkPath(url: string): string | null {
  try {
    const parsed = new URL(url);
    if (!DEEP_LINK_HOSTS.includes(parsed.hostname)) return null;
    return parsed.pathname + parsed.search;
  } catch {
    return null;
  }
}

export function isUnauthorizedError(error: Error): boolean {
  return /^401: .*Unauthorized/.test(error.message) || 
         error.message.includes('401') ||
         error.message.includes('Unauthorized');
}

export function isAuthError(error: Error): boolean {
  return isUnauthorizedError(error) || 
         error.message.includes('403') ||
         error.message.includes('Forbidden');
}